import React from 'react'
import { AccountDetails } from '../../../types'
import { StandardDl } from './StandardDl'
import { amountFormatter } from '../../../utils/formatter'

export const InterestWithheldYtdDl: React.FC<{
  account: AccountDetails
}> = ({ account }) =>
  // istanbul ignore next // interestWithheldYtd can only be a number
  account.interestWithheldYtd &&
  typeof account.interestWithheldYtd === 'number' &&
  !account.retirementAccountIndicator ? (
    <StandardDl
      title="Interest Withheld YTD:"
      definition={amountFormatter.format(account.interestWithheldYtd)}
    />
  ) : null
